var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthcareStep3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 90,
    viewBox: "0 0 67 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3651_687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.800195 13.3H65.3002V82.3C65.3002 86.1 62.2002 89.2 58.4002 89.2H7.6002C3.8002 89.2 0.700195 86.1 0.700195 82.3L0.800195 13.3Z",
    fill: "white",
    stroke: "#004137",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5001 21.2V8.60001C42.6001 6.80001 41.6001 4.30001 41.6001 2.60001C41.6001 0.900009 39.6001 1.00001 39.6001 1.00001H33.7001H32.8001H26.9001C26.9001 1.00001 24.9001 0.900009 24.9001 2.60001C24.9001 4.30001 23.9001 6.80001 24.0001 8.60001V21.2C24.0001 21.2 23.7001 23.8 26.0001 23.8H32.8001C33.4001 23.8 33.7001 23.8 33.7001 23.8H40.5001C42.8001 23.8 42.5001 21.2 42.5001 21.2Z",
    fill: "#9E8959",
    stroke: "#9E8959",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2998 4.5V20.1",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4004 6.39999V20.1",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0996 6.39999V20.1",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 24.4V39.4",
    stroke: "#004137",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9004 24.4V39.4",
    stroke: "#004137",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7002 29.4H39.0002V39.4H30.7002V29.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7002 39.4V29.4H39.0002",
    stroke: "#9E8959",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9 33.5V32.7H34V33.5H39.9Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9 34.3V33.9H34V34.3H39.9Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9 35.5V35.1H34V35.5H39.9Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9 37.4V37.1H34V37.4H39.9Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9 39V38.6H34V39H39.9Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2998 39.3H64.6998",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3651_687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcareStep3);
export default __webpack_public_path__ + "static/media/healthcare-step-3.4776b44387f08f17d883ae131865d765.svg";
export { ForwardRef as ReactComponent };